module.exports = __webpack_public_path__ + "static/fonts/manrope-semibold.b9eb20ae.woff2";